import {Intervals} from "../../Intervals"

/**
 * Detailed Alarm Report settings schema.
 *
 * The report itself has no per-run configuration beyond the delivery schedule:
 * the pre-schema DetailedAlarmReportSettings.vue rendered only the interval and
 * (when weekly) the day to send. Those map onto the shared "Scheduled Delivery"
 * section, so the whole report is data. Setting keys are unchanged from that
 * component, so saved templates are unaffected.
 */
export default {
    slug: 'detailed-alarm-report',
    icon:
        '<path stroke="none" d="M0 0h24v24H0z" fill="none"/>'
        + '<path d="M11 17h-7a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6" />'
        + '<path d="M9 17v1a3 3 0 0 0 2.685 2.984" />'
        + '<path d="M15 18a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />'
        + '<path d="M20.2 20.2l1.8 1.8" />',
    permission: 'manage_detailed_alarm_report',
    title: 'Detailed Alarm',
    description: 'Every alarm on the points you choose, and what happened with each one.',
    info: 'For each selected point: its current alarm limits, then every alarm that started in the period, with its start time, how long it took to resolve (or that it is still open), and every action and comment logged.',

    sections: [
        {
            // Only meaningful on a saved template: this is the recurring send
            // schedule. On-demand runs pick their window on the run form, so
            // this section is hidden there (matches Excursion).
            title: 'Scheduled Delivery',
            description: 'Automatically send this report on a recurring schedule.',
            showIf: ({isSavable}) => isSavable === true,
            fields: [
                {
                    key: 'interval',
                    type: 'select',
                    label: 'Send frequency',
                    description: 'How often the report is emailed, around 1 AM site time. Daily covers the previous day, weekly the 7 days before, semi-monthly each half month, and monthly the previous month.',
                    options: Intervals.STANDARD_INTERVAL_OPTIONS,
                    fromContext: true,
                },
                {
                    key: 'weekday',
                    type: 'select',
                    label: 'Day to receive report',
                    description: 'The day the weekly report is emailed, around 1 AM site time. It covers the 7 days ending the day before.',
                    options: Intervals.WEEKDAY_OPTIONS,
                    showIf: ({interval}) => interval === Intervals.WEEKLY,
                },
            ],
        },
    ],
}
